/**
 * TanStack Query key conventions. Every patient-scoped key starts with ['patient', id] so a single
 * invalidation (e.g. after break-glass or a role switch) refreshes everything shown for that patient.
 */
export const qk = {
  me: ['me'] as const,
  banners: ['system-banners'] as const,
  manifest: ['release-manifest'] as const,
  breakGlassActive: ['break-glass', 'active'] as const,

  patient: (id: string) => ['patient', id] as const,
  access: (id: string) => ['patient', id, 'access'] as const,
  summary: (id: string) => ['patient', id, 'summary'] as const,
  timeline: (id: string, kind?: string) => ['patient', id, 'timeline', kind ?? 'all'] as const,
  problems: (id: string, status?: string) => ['patient', id, 'problems', status ?? 'all'] as const,
  medications: (id: string, status?: string) => ['patient', id, 'medications', status ?? 'all'] as const,
  allergies: (id: string) => ['patient', id, 'allergies'] as const,
  observations: (id: string, category?: string) => ['patient', id, 'observations', category ?? 'all'] as const,
  trend: (id: string, code: string) => ['patient', id, 'trend', code] as const,
  results: (id: string) => ['patient', id, 'results'] as const,
  notes: (id: string) => ['patient', id, 'notes'] as const,
  orders: (id: string) => ['patient', id, 'orders'] as const,
  documents: (id: string) => ['patient', id, 'documents'] as const,
  careTeam: (id: string) => ['patient', id, 'care-team'] as const,
  careGaps: (id: string) => ['patient', id, 'care-gaps'] as const,
  carePlans: (id: string) => ['patient', id, 'care-plans'] as const,
  consents: (id: string) => ['patient', id, 'consents'] as const,
  proxies: (id: string) => ['patient', id, 'proxies'] as const,
  encounters: (id: string) => ['patient', id, 'encounters'] as const,

  note: (id: string) => ['note', id] as const,
  order: (id: string) => ['order', id] as const,
  result: (id: string) => ['result', id] as const,
  appointments: (params: object) => ['appointments', params] as const,
  inbox: (params: object) => ['inbox', params] as const,
  inboxCounts: ['inbox', 'counts'] as const,
  tasks: (params: object) => ['tasks', 'list', params] as const,
};
